import { storeAPI } from '@/common/service/ApiList';
import ServiceExec from '@/common/utils/ServiceExec';
import dayjs from 'dayjs';
import store from '@/store';
import { cloneDeep } from 'lodash';

export default {
  async fetchReviewList({getters, commit, state }, payload) {
    const {  totalPage, limit } = state.pageInfo;
    const condition = getters['getCondition']


    if( totalPage < condition.page) return
    const { status, data } = await ServiceExec.get(
      storeAPI.store_reviews,
      {
        ...payload,
        ...condition
      }
    );

    if (data) {
      const { pageInfo, list } = data;
      commit('setPageInfo', pageInfo);
      commit('setPage', condition.page + 1);
      commit('setTotalPage', pageInfo?.totalPage ?? 2);
      commit('setList', list ?? []);
    } else {
      commit('initList');
    }
  },

  async initAdminReviewList({ commit, state }, payload) {
    commit('initList');
    const { page, totalPage, limit } = state;
    if (page > totalPage) return;

    const { status, data } = await ServiceExec.get(
      admin_reviewAPI.review_list,
      payload
    );
    const { pageInfo, list } = data;
    commit('setPage', page + 1);
    commit('setTotalPage', pageInfo?.totalPage ?? 2);
    commit('setAdminReviewList', list ?? []);
  },

  async getDetail({ getters, commit, state }, review) {
    commit('setDetail', review);
  },

  async report({ commit }, payload) {
    const { status, data } = await ServiceExec.post(
      admin_reviewAPI.report,
      payload
    );

    return data;
  }
};
